import { useCallback, useRef, useState, useEffect } from 'react';

import '../Analizadores';

import Popup from 'devextreme-react/popup';

import { useApiConfiguration } from '../../../api/api.configuration';

import { useScreenSize } from '../../../utils/media-query';

import DataGrid, { Column, Button as Butt, Editing, KeyboardNavigation, Paging, Scrolling, Sorting, StateStoring, Selection, FilterRow, SearchPanel } from 'devextreme-react/data-grid';

import DropDownBox, { DropDownBoxTypes } from 'devextreme-react/drop-down-box';

import { SysIAnalitos } from '../../../types/types.analitos';

import { Rpm_AnalizadoresAnalitos } from '../../../types/types.analizadores';
import { newToast } from '../../../components';

export const ModalAnalytesByAnalyzer = ({ visible, setVisible, idAz, Analyzer, Analitos }: { visible: boolean; setVisible: (value: boolean) => void; idAz: number; Analyzer: string; Analitos: SysIAnalitos[] }) => {
  const { getAnalytesByAnalyzer, newAnalyzerAnalyte, setAnalyzerAnalyte, deleteAnalyzerAnalyte } = useApiConfiguration();
  const { isMedium, isSmall } = useScreenSize();
  const [gridBoxValue, setGridBoxValue] = useState([2]);
  const [dataAnalyzer, setDataAnalyzer] = useState<Rpm_AnalizadoresAnalitos[]>([]);
  const [isGridBoxOpened, setIsGridBoxOpened] = useState(false);
  const [selectedAnalito, setSelectedAnalito] = useState<SysIAnalitos | null>(null);
  const dataRef = useRef<DataGrid>(null);
  // Efecto para cargar datos cuando cambia idAz o cuando el modal se hace visible
  useEffect(() => {
    if (visible && idAz > 0) {
      fetchData();
    }
    if (!visible) {
      setGridBoxValue([]);
      setDataAnalyzer([]);
    }
  }, [visible]);

  const fetchData = async () => {
    if (idAz <= 0) {
      return;
    }
    try {
      const res = await getAnalytesByAnalyzer(idAz);

      if (res && Array.isArray(res)) {
        setDataAnalyzer(res);
      } else {
        console.warn('Respuesta inesperada de getAnalytesByAnalyzer:', res);
        setDataAnalyzer([]);
      }
    } catch (error) {
      console.error('Error al cargar datos de analizadores:', error);
      setDataAnalyzer([]);
    }
  };

  // const customDataSrc = useMemo(() => {
  //   return new CustomStore({
  //     key: 'Raa_Id',
  //     load: () => {
  //       return Promise.resolve({
  //         data: dataAnalyzer,
  //         totalCount: dataAnalyzer.length,
  //       });
  //     },
  //     remove: async (key) => {
  //       return deleteAnalyzerAnalyte({ Id: key }).then((res) => {
  //         if (res) {
  //           fetchData();
  //         }
  //       });
  //     },
  //     update: async (key, values) => {
  //       try {
  //         const currentItem = dataAnalyzer.find((item) => item.Raa_Id === key);
  //         if (!currentItem) {
  //           throw new Error('No se encontró el analizador para actualizar');
  //         }
  //         const updatedItem = { ...currentItem, ...values };
  //         await setAnalyzerAnalyte({ RpmAnalito: updatedItem, IdRpm: key });
  //         return fetchData();
  //       } catch (error) {
  //         console.error('Error actualizando el Analizador', error);
  //         throw new Error('Error actualizando el Analizador');
  //       }
  //     },
  //   });
  // }, [dataAnalyzer, deleteAnalyzerAnalyte, setAnalyzerAnalyte, fetchData]);

  // const customData = useMemo(() => {
  //   return new DataSource({
  //     store: customDataSrc,
  //     reshapeOnPush: true,
  //   });
  // }, [customDataSrc]);

  const handleVisible = useCallback(() => {
    setVisible(false);
  }, [setVisible]);

  useEffect(() => {
    if (!selectedAnalito || !idAz || idAz === -1) return;
    //buscamos que el analito no exista en la tabla de analizadores
    const analitoExists = dataAnalyzer.some((item) => item.Raa_An_Id === selectedAnalito.An_Id && item.Raa_Az_Id === idAz);
    if (analitoExists) {
      setIsGridBoxOpened(false);
      setSelectedAnalito(null);
      newToast('WARNING', 'El analito ya existe en el analizador seleccionado', 3);
      return;
    }

    const updatedDataRpm: Rpm_AnalizadoresAnalitos = {
      Raa_Id: 0,
      Raa_An_Id: selectedAnalito.An_Id,
      Raa_Az_Id: idAz,
      Raa_Sufijo: null,
      Raa_HomEnvio: '',
      Raa_HomRecibo: '',
      Raa_Tipo: 1,
      Raa_Variante: 1,
      Raa_HomMuestra: '',
      Raa_HomMuestraNum: null,
    };

    newAnalyzerAnalyte({ RpmAnalito: updatedDataRpm }).then((res) => {
      if (res === 105) {
        fetchData();
      }
    });
    setIsGridBoxOpened(false);
    setSelectedAnalito(null);
  }, [selectedAnalito]);

  const handleConfigureClick = useCallback(
    (e) => {
      const { data }: { data: SysIAnalitos } = e.row;
      setSelectedAnalito(data);
    },
    [setSelectedAnalito]
  );

  const dataGridRender = useCallback(() => {
    return (
      <DataGrid dataSource={Analitos || []} ref={dataRef} hoverStateEnabled={true} showBorders={true} selectedRowKeys={gridBoxValue} height='100%' highlightChanges={false}>
        <Selection mode='single' />
        <Scrolling mode='virtual' />
        <Paging enabled={true} />
        <FilterRow visible={true} />
        <Column name='An_Id' caption='ID' visible={true} dataField='An_Id' width={100} alignment='center' />
        <Column name='An_Abreviatura' caption='ABREV' visible={true} dataField='An_Abreviatura' width={120} alignment='left' />
        <Column name='An_Nombre' caption='ANALITO' visible={true} dataField='An_Nombre' alignment='left' />
        <Column type='buttons' caption='ACCIÓN'>
          <Butt hint='Configurar' icon='plus' visible={true} disabled={false} onClick={handleConfigureClick} />
        </Column>
      </DataGrid>
    );
  }, [Analitos, gridBoxValue, handleConfigureClick]);

  const gridBoxDisplayExpr = (item: { An_Id: any; An_Nombre: any }) => item && `${item.An_Nombre} <${item.An_Id}>`;

  const handleSelectedData = useCallback((e: DropDownBoxTypes.ValueChangedEvent) => {
    setGridBoxValue(e.value);
  }, []);

  const onGridBoxOpened = useCallback((e: DropDownBoxTypes.OptionChangedEvent) => {
    if (e.name === 'opened') {
      setIsGridBoxOpened(e.value);
    }
  }, []);

  const handleUpdate = useCallback(
    (e) => {
      const updatedData = {
        ...e.oldData,
        ...e.newData,
        Analizadores: null,
        Analitos: null,
      };
      const idRpm = Number(e?.key?.Raa_Id ?? e?.key ?? updatedData.Raa_Id);
      //Actualizar la data en el servidor
      setAnalyzerAnalyte({ RpmAnalito: updatedData, IdRpm: idRpm }).then((res) => {
        if (res === 105) {
          fetchData();
        }
      });
    },
    [setAnalyzerAnalyte]
  );

  const handleRemove = useCallback(
    (e) => {
      e.cancel = true; // Evitar la eliminación automática de la fila
      const dataToDelete = e.data.Raa_Id; // Obtener el ID del elemento a eliminar
      deleteAnalyzerAnalyte({ Id: dataToDelete }).then((res) => {
        if (res === 108) {
          fetchData();
        }
      });
    },
    [deleteAnalyzerAnalyte]
  );

  return (
    <Popup width={1200} height='auto' maxHeight="90%" fullScreen={isMedium || isSmall} visible={visible} onHidden={handleVisible} title={`${idAz} - ${Analyzer}`} showTitle={true} showCloseButton={true}>
      <div>
        <DropDownBox dataSource={Analitos || []} value={gridBoxValue} opened={isGridBoxOpened} valueExpr='An_Id' displayExpr={gridBoxDisplayExpr} deferRendering={false} inputAttr={{ 'aria-label': 'Owner' }} placeholder='ANALITOS' showClearButton={true} onValueChanged={handleSelectedData} onOptionChanged={onGridBoxOpened} contentRender={dataGridRender} />
        <br />
        <DataGrid className='grid' dataSource={dataAnalyzer} keyExpr='Raa_Id' highlightChanges={false} onRowUpdating={handleUpdate} onRowRemoving={handleRemove} hoverStateEnabled={true} height='100%' width={'100%'} repaintChangesOnly={false} rowAlternationEnabled={true} showColumnLines={true}>
          <Scrolling columnRenderingMode='virtual' />
          <Sorting mode='multiple' />
          <SearchPanel visible={true} />
          <Selection mode='single' />
          <KeyboardNavigation editOnKeyPress={true} enterKeyAction='startEdit' enterKeyDirection='column' />
          <Paging enabled={false} />
          <StateStoring enabled={true} type='custom' />
          <Editing mode='form' allowUpdating={true} allowDeleting={true} selectTextOnEditStart={true} texts={{ saveRowChanges: 'Guardar', cancelRowChanges: 'Cancelar', deleteRow: 'Eliminar' }} />
          <Column allowGrouping={false} allowSorting={false} caption='ID' allowEditing={false} visible={true} dataField='Analitos.An_Id' width={80} alignment='center' name='An_Id' />
          <Column allowGrouping={false} caption='ANALITO' visible={true} allowEditing={false} dataField='Analitos.An_Nombre' alignment='left' />
          <Column allowGrouping={false} caption='ABREV' allowEditing={false} allowSorting={false} dataField='Analitos.An_Abreviatura' width={80} alignment='center' />
          <Column allowGrouping={false} caption='SUFIJO' allowEditing={true} allowSorting={false} dataField='Raa_Sufijo' width={67} alignment='center' />
          <Column allowGrouping={false} caption='HOM ENVIO' allowEditing={true} allowSorting={false} dataField='Raa_HomEnvio' width={100} alignment='center' />
          <Column allowGrouping={false} caption='HOM RECIBO' allowEditing={true} allowSorting={false} dataField='Raa_HomRecibo' width={110} alignment='center' />
          <Column allowGrouping={false} caption='HOM T. MUESTRA' allowEditing={true} allowSorting={false} dataField='Raa_HomMuestra' dataType='string' width={130} alignment='center' />
          <Column allowGrouping={false} caption='HOM T. MUESTRA NUM' allowEditing={true} allowSorting={false} dataField='Raa_HomMuestraNum' dataType='number' width={120} alignment='center' />
          <Column allowGrouping={false} caption='TIPO' allowEditing={true} allowSorting={false} dataField='Raa_Tipo' width={60} alignment='center' />
          <Column type='buttons' caption='ACCIÓN' width={70}>
            <Butt name='edit' />
            <Butt name='delete' />
          </Column> 
        </DataGrid>
      </div>
    </Popup>
  );
};